var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "slideSwitchSelect",
      staticClass: "slideSwitchSelect",
      style: {
        "--left": _vm.slideSwitchSelect.left + "px",
        "--width": _vm.slideSwitchSelect.width + "px",
        "--top": _vm.slideSwitchSelect.top + "%"
      },
      attrs: { "data-content": _vm.slideSwitchSelect.content }
    },
    _vm._l(_vm.slideSwitchList, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          on: {
            click: function($event) {
              return _vm.change(item)
            }
          }
        },
        [_vm._v(_vm._s(item.content))]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7529ae30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7529ae30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mSlideSwitch.vue
// module id = null
// module chunks = 